import React, { PureComponent } from 'react';
import { bool, string, func } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { formValueSelector, submit } from 'redux-form';
import DOMPurify from 'dompurify';
import { addTargetBlankToSelector } from '@widergy/web-utils/lib/dom';

import { actionCreators as accountActions } from 'redux/accountHandlers';
import { DIGITAL_BILL_FORM } from 'constants/general';
import UTModal from 'app/components/UTModal';
import { SERVICE_ADHERENCE } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { trackEvent } from 'services/AnalyticsService';
import { categories, actions, labels } from 'constants/analytics';
import { accountsPropTypes } from 'types/accountTypes';

import ServiceAdherence from './layout';
import styles from './styles.module.scss';

const ACCOUNT_LIST = 'accountList';

class AdherenceWithTermsOfServiceContainer extends PureComponent {
  componentWillMount = () => this.props.dispatch(accountActions.getTermsOfService(DIGITAL_BILL_FORM));

  componentWillReceiveProps = nextProps => {
    if (
      this.props.acceptServiceAgreementLoading !== nextProps.acceptServiceAgreementLoading &&
      !nextProps.acceptServiceAgreementLoading
    ) {
      this.props.handleModalClose();
    }
  };

  componentDidUpdate() {
    addTargetBlankToSelector('a');
  }

  onAcceptServiceAgreement = values => {
    if (values.accountList && values.accountList.length > 0) {
      this.props.dispatch(
        accountActions.acceptServiceAgreement(DIGITAL_BILL_FORM, values.accountList, false)
      );
    } else {
      this.props.handleModalClose();
      trackEvent(
        categories.FACTURACION,
        actions.NO_ADHESION_FACTURA_DIGITAL,
        labels.NO_ADHESION_FACTURA_DIGITAL_OK
      );
    }
  };

  createHtml = htmlInput => ({ __html: DOMPurify.sanitize(htmlInput) });

  handleCheckTerms = () => this.setState(prevState => ({ acceptedTerms: !prevState.acceptedTerms }));

  handleAcceptServiceAgreement = () => this.props.dispatch(submit(SERVICE_ADHERENCE));

  render() {
    const acceptButton = {
      text:
        this.props.accountList && this.props.accountList.length > 0
          ? message('Commons:accept')
          : message('Commons:cancel'),
      onPress:
        this.props.accountList && this.props.accountList.length > 0
          ? this.handleAcceptServiceAgreement
          : this.props.handleModalClose,
      className: styles.termsAndConditionsButton
    };

    return (
      <UTModal
        isOpen={this.props.modalIsOpen}
        onRequestClose={this.props.handleModalClose}
        contentLabel={message('ServiceAdherence:digitalBillAdherence')}
        title={message('ServiceAdherence:digitalBillAdherence')}
        acceptButton={
          !this.props.termsOfServiceLoading && !this.props.acceptServiceAgreementLoading && acceptButton
        }
      >
        <ServiceAdherence
          termsOfServiceLoading={this.props.termsOfServiceLoading}
          acceptServiceAgreementLoading={this.props.acceptServiceAgreementLoading}
          termsOfService={this.createHtml(this.props.termsOfService)}
          onSubmit={this.onAcceptServiceAgreement}
          accounts={this.props.accounts}
          accountListField={ACCOUNT_LIST}
        />
      </UTModal>
    );
  }
}

AdherenceWithTermsOfServiceContainer.propTypes = {
  termsOfServiceLoading: bool,
  termsOfService: string,
  modalIsOpen: bool,
  accounts: accountsPropTypes,
  accountList: accountsPropTypes,
  handleModalClose: func.isRequired,
  acceptServiceAgreementLoading: bool
};

export const currentAccountSelector = (store, props) =>
  store.account.accounts.find(account => account.client_number === props.account);

export const accountsSelector = createSelector(currentAccountSelector, account =>
  account
    ? [
        {
          id: account.client_number,
          client_number: account.client_number,
          address: account.address
        }
      ]
    : []
);

const formSelector = formValueSelector(SERVICE_ADHERENCE);

const mapStateToProps = (store, props) => ({
  termsOfService: store.account.termsOfService,
  termsOfServiceLoading: store.account.termsOfServiceLoading,
  acceptServiceAgreementLoading: store.account.acceptServiceAgreementLoading,
  accounts: accountsSelector(store, props),
  accountList: formSelector(store, ACCOUNT_LIST)
});

export default connect(mapStateToProps)(AdherenceWithTermsOfServiceContainer);
